(function () {

    'use strict';

    angular
        .module('app.search')
        .factory('ParamIteratorService', [ParamIteratorService]);

    function ParamIteratorService() {
        function forEachParam(params, searchContext, simpleConditionAction, rangedConditionAction) {
            var ranged = {};
            simpleConditionAction = simpleConditionAction || function () {};
            rangedConditionAction = rangedConditionAction || function () {};
            for (var pn in params) if (params.hasOwnProperty(pn)) {
                var pv = params[pn];
                var apiCondName;
                if (pv && (pv.length == undefined || pv.length > 0) && !params[pn + ".all"]) {
                    // ranged conditions
                    if (pn.match(/.*\.l/) || pn.match(/.*\.u/)) {
                        apiCondName = pn.substring(0, pn.length - 2);
                        if (searchContext.getCondition(apiCondName)) {
                            if (!ranged[apiCondName]) {
                                ranged[apiCondName] = 1;
                                rangedConditionAction(apiCondName, params[apiCondName + ".l"], params[apiCondName + ".u"]);
                            }
                        }
                    }
                    // regular conditions
                    else {
                        apiCondName = pn;
                        var pvs = pv;
                        if (typeof pvs === "string") pvs = pv.split(",");
                        if (searchContext.getCondition(apiCondName) && !params[apiCondName + ".all"])
                            simpleConditionAction(apiCondName, pvs);
                    }
                }
            }
        }

        return {"forEachParam": forEachParam};
    }

})();


// WEBPACK FOOTER //
// ./app/search/components/service/ParamIteratorService.js